import { render, staticRenderFns } from "./Baja2.vue?vue&type=template&id=c4a7a9de&"
import script from "./Baja2.vue?vue&type=script&lang=js&"
export * from "./Baja2.vue?vue&type=script&lang=js&"
import style0 from "./Baja2.vue?vue&type=style&index=0&id=c4a7a9de&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports